/**
 * Step 9: Restrições no CPF
 * Coleta informações sobre restrições no CPF do usuário
 * IMPORTANTE: Este step tem branching condicional
 */

import React, { useState } from 'react';
import { StepContainer, ChoiceButtons, StepNavigation } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

const Step9_Restricoes: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState<Pick<FormData, 'cpfRestrictions'>>({ cpfRestrictions: data.cpfRestrictions || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const options = [
    { label: 'Tenho o nome limpo', value: 'clean' },
    { label: 'Tenho restrições', value: 'with-restrictions' },
  ];

  const handleSelectOption = (value: string) => {
    setLocalData({ cpfRestrictions: value as 'clean' | 'with-restrictions' | '' });
    setErrors({});
  };

  const handleNext = () => {
    if (!localData.cpfRestrictions) {
      setErrors({ cpfRestrictions: 'Selecione uma opção' });
      return;
    }

    updateFields(localData);
    
    // BRANCHING: Determina o próximo step baseado na resposta
    let nextStepId: string | undefined;
    if (localData.cpfRestrictions === 'clean') {
      // Se não tem restrições, pula para estado civil
      updateFields({
        restrictionDetails: '',
        avalist: '',
      });
      nextStepId = 'step21_mae';
    } else if (localData.cpfRestrictions === 'with-restrictions') {
      // Se tem restrições, vai para revendedora (avalista)
      nextStepId = 'step9_restricoes_detalhes';
    }
    //return;
    onNext(localData, nextStepId);
  };

  const handlePrevious = () => {
    onPrevious();
  }

  return (
    <StepContainer
      title=""
      description=""
    >
      <div className="mb-6">
        <p className="font-semibold mb-2">Você tem restrições no CPF?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Isso é importante para processar sua candidatura. Seja honesto para que a gente possa entender melhor sua situação.
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
          <p className="text-blue-900 text-sm">
            💡 Restrições podem incluir: SPC, Serasa, Cheques devolvidos ou débitos em aberto.
          </p>
        </div>
      </div>
      <div>
        <ChoiceButtons
          options={options}
          selected={localData.cpfRestrictions}
          onSelect={handleSelectOption}
        />
        {errors.cpfRestrictions && (
          <p className="text-red-600 text-sm mt-2">{errors.cpfRestrictions}</p>
        )}
      </div>

      <StepNavigation
        onNext={handleNext}
        onPrevious={handlePrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step9_Restricoes;
